import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObserversModule } from '@angular/cdk/observers';

import { CarouselContainer } from '@app/modules/carousel/carousel/carousel.container';
import { PaginationDsComponent } from '@design-system/components/molecules/pagination/pagination.component';

@NgModule({
  declarations: [CarouselContainer],
  imports: [
    CommonModule,
    ObserversModule,
    PaginationDsComponent,
  ],
  exports: [CarouselContainer]
})
export class CarouselModule { }
